export default {"src":"/_next/static/media/2d-plans.530637e8.svg","height":53,"width":54,"blurWidth":0,"blurHeight":0};